function checkForClassAddition(mutationsList) {
  mutationsList.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1 && node.matches("abra-popup")) {
        // Observe the newly added abra-popup element
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (
              mutation.type === "attributes" &&
              mutation.attributeName === "class"
            ) {
              if (mutation.target.classList.contains("abra-popup--show")) {
                $("body").addClass("adbrActivated");
              }
            }
          });
        });
        observer.observe(node, { attributes: true });
      }
    });
  });
}

const observer = new MutationObserver(checkForClassAddition);

const config = { childList: true, subtree: true };

observer.observe(document.body, config);

$("body").on("click", ".abra-popup__close-button", function () {
  $("body").removeClass("adbrActivated");
});

$(document).scroll(function () {
  btnScroll();
});
function btnScroll() {
  var thresholds = [
    250, 240, 230, 220, 210, 200, 190, 180, 170, 160, 150, 140, 130, 120, 110,
    100, 90, 80,
  ];
  if ($(window).scrollTop() > 1200) {
    var addToCartButtonHeight = parseInt(
      $(".product-single__form-wrapper.sticky").outerHeight()
    );
    var addToCartActivated = 0;
    for (var i = 0; i < thresholds.length; i++) {
      if (addToCartButtonHeight > thresholds[i]) {
        if (i != 0) {
          addToCartActivated = thresholds[i - 1];
        }
        break;
      }
    }
    $("body").addClass(`addToCartActivated-${addToCartActivated}`);
  } else {
    for (var i = 0; i < thresholds.length; i++) {
      $("body").removeClass(`addToCartActivated-0`);
      $("body").removeClass(`addToCartActivated-${thresholds[i]}`);
    }
  }
}
btnScroll();
